export default "__VITE_ASSET__Dwg_IrJJ__"